export const FontWeight = {
  Light: '300',
  Regular: '400',
  Medium: '500',
  Bold: '700',
};
